<template>
    <div id="app">
        <Navbar/>
        <main>
            <router-view></router-view>
        </main>
        <Contato/>
        <Footer/>
    </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Contato from '@/components/contato/Contato.vue'
import Footer from '@/components/Footer.vue'

export default {
    components: {
        Navbar,
        Contato,
        Footer
    }
}
</script>

<style lang="sass">
#app main
    min-height: 100vh
    display: flex
    align-items: center
    justify-content: center
</style>
